import React, { useMemo } from 'react';
import { Box, Grid, Theme, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { missingField } from 'app/constants';
import SkillSetTitle from './SkillSetTitle';
import SkillSetQualifications from './SkillSetQualifications';
import { useSelector } from 'react-redux';
import { selectSkillsetDataUIFormat } from '@AMIEWEB/NewOrder/Store/Order.selectors';
import { ISkillSetGroup } from '@AMIEWEB/Facility/FacilityStore/Facility.model';
import { selectOrderDetailsUIView } from '@AMIEWEB/Order/Store/Order.selectors';
import { AndOrOperatorSymbolToText } from 'app/enums/Common';
import { useInjectReducer } from 'redux-injectors';
import { orderCreationNewReducer, orderCreationNewSliceKey } from '@AMIEWEB/NewOrder/Store/OrderCreation.redux';
import { transformSkillSetGroupsDataWithoutLicense } from '../helper';

const useStyles = makeStyles()((theme: Theme) => ({
  boxBorder: {
    flexGrow: 1,
    borderColor: theme.palette.framework.system.whisper,
    border: `1px solid ${theme.palette.system.lightGrey}`,
    borderRadius: '5px',
    background: `${theme.palette.system.white}`,
  },
  titleBox: {
    backgroundColor: theme.palette.system.grayChip,
    borderBottom: `1px solid ${theme.palette.system.lightGrey}`,
    borderRadius: '5px 5px 0 0',
  },
  operationText: {
    fontSize: 16,
    fontWeight: 500,
    margin: '3px 0px',
  },
}));

interface OrderDetailsOneProps {
  isNewOrderCreation: boolean;
}

const Experiences = (props: OrderDetailsOneProps) => {
  useInjectReducer({ key: orderCreationNewSliceKey, reducer: orderCreationNewReducer });

  const { isNewOrderCreation } = props;
  const { classes } = useStyles();
  const skillSetGroupsOrderStore = useSelector(selectOrderDetailsUIView);
  const skillSetGroupsStore = useSelector(selectSkillsetDataUIFormat);
  let skillSetGroups: ISkillSetGroup;
  if (isNewOrderCreation) {
    skillSetGroups = transformSkillSetGroupsDataWithoutLicense({...skillSetGroupsStore});
  } else {
    skillSetGroups = skillSetGroupsOrderStore?.orderDetails?.skillSetGroup;
  }
  
  const renderData = (group, index) => {
    return group?.skillsets?.map((skillSetData, skillSetIndex) => (
      <>
        <Grid className={classes.boxBorder} key={index}>
          <Grid className={classes.titleBox} p={2} display="flex" flexDirection="column" alignItems="center" item>
            {skillSetData?.skillSet ? (
              <SkillSetTitle skillSetData={skillSetData?.skillSet} isPrimary={skillSetData?.isPrimary} />
            ) : (
              <Box key={skillSetIndex}>{missingField}</Box>
            )}
          </Grid>
          <SkillSetQualifications skillSetData={skillSetData} />
        </Grid>
        {group?.skillsets?.length - 1 !== skillSetIndex && group?.operation && (
          <Typography className={classes.operationText}>{AndOrOperatorSymbolToText[group?.operation]}</Typography>
        )}
      </>
    ));
  };

  const SkillSets = useMemo(() => {
    return (
      <>
        {skillSetGroups?.groups && skillSetGroups.groups.length > 0 ? skillSetGroups.groups.map((group, index) =>
          group?.skillsets?.length ? renderData(group, index) : <Box key={index}>{missingField}</Box>,
        ) : null}
      </>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isNewOrderCreation, skillSetGroupsOrderStore?.orderDetails?.skillSetGroup, skillSetGroups ]);

  return <>{SkillSets}</>;
};

export default Experiences;
